import React, { useRef, useState, useEffect } from "react";
import { useAuth } from "../Context/AuthContext";
import { Link, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCurrentPage } from "../Redux/Actions/activePage";
import {Row,Col} from 'reactstrap';

export default function SignUp() {
  //refs contain current.value
  const nameRef = useRef();
  const emailRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  //destructure from auth
  const { signUp } = useAuth();
  //hooks
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  //redirect
  const history = useHistory();
  const dispatch = useDispatch();
  const regexPattern = /^(?=.*[A-Z])(?=.*[0-9]).+$/ //pattern for atleast one capital letter and one number
  async function handleSubmit(e) {

    e.preventDefault();
    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError("Lösenorden matchar inte.");
    }
    if (!regexPattern.test(passwordRef.current.value)) {
      return setError("Lösenordet måste innehålla minst en versal och minst en siffra.");
    }
    try {
      //reset error state
      setError("");
      //start loading state
      setLoading(true);
      //signing up with email and password
      await signUp(
        nameRef.current.value,
        emailRef.current.value,
        passwordRef.current.value
      );
      //redirect from signup after succesfull signup
      history.push("/login");
    } catch (err) {
      //err.code catches firebase error message. Use to set more helpful error message
      if (err.code === "auth/email-already-in-use") {
        setError("Din email finns redan.");
      }
      if (err.code === "auth/weak-password") {
        setError(
          "Ditt lösenord är för svagt, välj ett med minst 6 karaktärer."
        );
      } else {
        //rest of errors
        console.log(err.code);
        setError("Lyckades inte att skapa nytt konto.");
      }
    }
    //restore loading to false
    setLoading(false);
  }
  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      dispatch(setCurrentPage("Signup"));
    }
    return () => {
      isMounted = false;
    };
  }, [dispatch]);


  return (
    <Row className="mt-5 d-flex align-items-center justify-content-center">
      <Col xs={20}>

        <Row>
          <Col 
            xs={20} 
            className="offset-17 lead fw-bold text-muted responsive-fontsize"
            style={{cursor:'default'}}
          >
            Skapa ett konto
          </Col>
        </Row>

        {error ? 
          <Row>
            <Col 
              xs={40} 
              className="text-center text-danger responsive-fontsize"
              style={{cursor:'default'}}
            >
              {error}
            </Col>
          </Row>
        : ""}    

        <form onSubmit={handleSubmit}>

          <Row className="mt-3">
            <Col 
              xs={10} 
              className="offset-7 d-flex align-items-center justify-content-end responsive-fontsize"
              style={{cursor:'default'}}
            >
              Namn:
            </Col>
            <Col xs={15} className="d-flex align-items-center justify-content-start">
              <input type="text" className="form-control" required ref={nameRef} autoComplete="new-password"/>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col 
              xs={10} 
              className="offset-7 d-flex align-items-center justify-content-end responsive-fontsize"
              style={{cursor:'default'}}
            >
              Email:
            </Col>
            <Col xs={15} className="d-flex align-items-center justify-content-start">
              <input type="email" className="form-control" required ref={emailRef} autoComplete="new-password"/>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col 
              xs={10} 
              className="offset-7 d-flex align-items-center justify-content-end responsive-fontsize"
              style={{cursor:'default'}}
            >
              Lösenord:
            </Col>
            <Col xs={15} className="d-flex align-items-center justify-content-start">
              <input type="password" className="form-control" required ref={passwordRef} autoComplete="new-password"/>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col 
              xs={10} 
              className="offset-7 d-flex align-items-center justify-content-end responsive-fontsize"
              style={{cursor:'default'}}
            >
              Bekräfta Lösenord:
            </Col>
            <Col xs={15} className="d-flex align-items-center justify-content-start">
              <input type="password" className="form-control" required ref={passwordConfirmRef} autoComplete="new-password"/>
            </Col>
          </Row>

          <Row>
            <Col xs={20} className="offset-17 mt-3">
              <button
                type="submit"
                className="btn btn-success responsive-fontsize"
                //when loading is true button is disabled, prevents multiple clicks when signing up
                disabled={loading}
              >
                Skapa konto
              </button>
            </Col>
          </Row>
          
          <Row className="mt-5">
            <Col xs={23} className="offset-17 responsive-fontsize" style={{cursor:'default'}}> 
              Har du redan ett konto ? <Link to="/login" className="ps-2 fw-bold">Logga in</Link>   
            </Col>
          </Row>
        
        </form>

      </Col>
    </Row>
    
  );
}

